import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
export type LeaderboardButtonProps = {
  scenarioUuid: string;
};

export function LeaderboardButton(props: LeaderboardButtonProps) {
  const navigate = useNavigate();

  const handleNavigateClick = () => {
    navigate(`/scenarios/${props.scenarioUuid}/leaderboard`);
  };

  return (
    <div className="relative">
      <button
        className="bg-white text-black py-2 px-4 rounded hover:bg-gray-200 transition-colors duration-300"
        onClick={handleNavigateClick}
      >
        Leaderboard
      </button>
    </div>
  );
}
